/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PrintAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function PrintAction({
  children,
  viewPath = "/App/Account/Content/Financial/Content/Statements/New/Actions/Content/PrintAction"
  
}) {
let selectedMergedPrintedValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'merged.printed',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 block={true}
 type={selectedMergedPrintedValueData ? "ghost" : "secondary"}
 size="small"
 marginTop={dtSpaceXxs}
 onClick={onClick}
 data="selected.merged.printed"
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Print"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}